import React from 'react';
import { CalendarDaysIcon, CheckIcon, ClipboardListIcon, ShieldIcon, UsersIcon } from 'lucide-react';
const stats = [[CalendarDaysIcon, '300+', 'Pagine'], [ClipboardListIcon, '300+', 'Sessioni'], [UsersIcon, '120+', 'Drill e giochi'], [ShieldIcon, 'Tutte', 'Le categorie']];
const tags = ['Minivolley / S3 (White, Green, Red)', 'Under 12 / Under 13 (Iniziazione)', 'Under 14 / Under 15 (Sviluppo)', 'Under 16 / Under 18 (Avanzato)', 'Alta Performance (Serie / Senior)'];
export function SystemSection() {
  return <section className="border-y-4 border-emerald-400 bg-[#10372a] px-5 py-20" data-id="element-212">
      <div className="mx-auto max-w-6xl text-center" data-id="element-213">
        <p className="inline-block bg-emerald-400 px-4 py-2 text-xs font-bold uppercase tracking-widest text-[#09281d]" data-id="element-214">
          Il sistema più completo per tecnici di pallavolo
        </p>
        <h2 className="mt-7 font-display text-5xl font-bold uppercase leading-none text-white sm:text-7xl" data-id="element-215">
          PALLAVOLO <span className="text-emerald-300" data-id="element-216">PRONTA™</span>
        </h2>
        <p className="mx-auto mt-6 max-w-2xl text-base font-medium leading-relaxed text-slate-300" data-id="element-217">
          Oltre 300 pagine di piani di allenamento, drill tecnici professionali,
          giochi, guide alla tecnica, preparazione fisica e strumenti di
          gestione del gruppo —{' '}
          <strong className="text-white" data-id="element-218">tutto pronto per te.</strong>
        </p>
        <div className="mt-11 grid grid-cols-2 gap-3 lg:grid-cols-4" data-id="element-219">
          {stats.map(([Icon, value, label]) => <div key={label} className="border border-emerald-300/25 bg-[#09281d] p-6" data-id="element-220">
              <Icon className="mx-auto h-7 w-7 text-emerald-300" data-id="element-221" />
              <p className="mt-4 font-display text-4xl font-bold text-white" data-id="element-222">
                {value}
              </p>
              <p className="text-xs font-bold uppercase tracking-widest text-slate-300" data-id="element-223">
                {label}
              </p>
            </div>)}
        </div>
        <div className="mt-4 border border-emerald-300/25 bg-[#09281d] p-7" data-id="element-224">
          <p className="text-xs font-bold uppercase tracking-[.2em] text-white" data-id="element-225">
            Copertura totale per ogni fascia d’età
          </p>
          <div className="mt-5 flex flex-wrap justify-center gap-2" data-id="element-226">
            {tags.map(tag => <span key={tag} className="flex items-center gap-1.5 border border-emerald-300/25 bg-[#10372a] px-3 py-2 text-xs font-bold text-white" data-id="element-227">
                <CheckIcon className="h-3.5 w-3.5 text-emerald-300" data-id="element-228" />
                {tag}
              </span>)}
          </div>
        </div>
      </div>
    </section>;
}